import Expert from '@/api/expert'

const initLoad = commit => commit('changeLoading', { isLoading: true })

const onSuccess = (commit, { data }) => {
  commit('updateExpertsList', { list: data.map(e => e.id) })
  commit('updateCollection', { collection: data })
  commit('changeLoading', { isLoading: false })
}

const onError = (commit, { error }) => {
  commit('changeLoading', { isLoading: false })
  throw error
}

export default {
  fetchAll: ({ commit }) => {
    initLoad(commit)
    return Expert.fetchAll()
      .then(({ data }) => onSuccess(commit, { data }))
      .catch(error => onError(commit, { error }))
  },
  fetch: ({ commit }, { id }) => {
    initLoad(commit)
    return Expert.fetch({ id })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('replaceItem', { item: data })
      })
      .catch(error => onError(commit, { error }))
  },
  updateRole: ({ commit }, { id, role }) => {
    initLoad(commit)
    return Expert.save({ id, data: { role } })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('replaceItem', { item: data })
      })
      .catch(error => onError(commit, { error }))
  },
  save: ({ commit }, { id, data }) => {
    initLoad(commit)
    if (data.password !== '') {
      data.password_confirmation = data.password
    }
    return Expert.save({ id, data })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('replaceItem', { item: data })
      })
      .catch(error => onError(commit, { error }))
  },
  updatePriority: ({ commit, getters }, { id, up }) => {
    const index = getters.experts.findIndex(e => e.id === id)
    if ((!up && index >= getters.experts.length - 1) ||
         (up && index <= 0)) {
      return
    }
    const newOrder = [...getters.experts.map(e => e.id)]
    const position = up ? -1 : 1
    newOrder[index] = newOrder[index + position]
    newOrder[index + position] = id
    commit('updateExpertsList', { list: newOrder })
    const priorities = newOrder.map((id, index) => ({ id, value: index }))
    priorities.forEach(p => commit('updateItem', { item: { id: p.id, priority: p.value } }))
    return Expert.updatePriorities({ priorities })
  },
  invite: ({ commit, getters }, { email, password }) => {
    initLoad(commit)
    return Expert.invite({ email, password, password_confirmation: password })
      .then(({ data }) => {
        onSuccess(commit, { data: [...getters.experts, data] })
        return data
      })
      .catch(error => onError(commit, { error }))
  },
  remove: ({ commit, getters }, { id }) => {
    initLoad(commit)
    return Expert.remove({ id })
      .then(({ data }) => {
        onSuccess(commit, { data: [...getters.experts].filter(e => e.id !== id) })
        return data
      })
      .catch(error => onError(commit, { error }))
  },
  availabilities: ({ commit }) => {
    initLoad(commit)
    return Expert.availabilities()
      .then(({ data }) => {
        data.forEach(e => commit('updateItem', { item: e }))
        return data
      })
      .catch(error => onError(commit, { error }))
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/experts/actions.js